// Backend Sestek.AgenticCX.Domain.Constants.WrapUp.WrapUpDefinitionConsts ile birebir eşleşir.
export const PredefinedWrapUpCodeId = {
  Sales: 1,
  Complaint: 2,
  FollowUp: 3,
  WrongNumber: 4,
  NoAnswer: 5,
  Other: 6,
  SessionInterrupted: 7,
  NotPrompted: 8,
} as const;
